import React from 'react';
import Logo from '../images/media/logo.png';
import HeaderPrint from '../Settings/headerPrint';
import FooterPrint from '../Settings/footerPrint';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { callingAPI } from '../config';
import Loader from '../Common/loader';
import moment from 'moment';

function LabOrderListPrint() {
	let { printId } = useParams();
	const [id, hospitalId] = printId.split('||');
	const [marginbottom, setmarginbottom] = useState('');
	const [margintop, setmargintop] = useState('');
	const [marginleft, setmarginleft] = useState();
	const [marginright, setmarginright] = useState('');

	const [pagesizeid, setpagesizeid] = useState('');
	const [memberDetails, setMemberDetails] = useState({});
	const [hospitalDetails, setHospitalDetails] = useState({});
	const [labOrderListResult, setLabOrderListResult] = useState([]);
	const [doctorDetails, setdoctorDetails] = useState([]);
	const [labordercreateddate, setlabordercreateddate] = useState('');
	const [grandTotal, setSrandTotal] = useState('');
	const [headingType, setHeadingType] = useState('Lab order Details');
	const [isData, setIsData] = useState(false);
	const [isCompleted, setIsCompleted] = useState('0')
	const [HospitalLogo, setHospitalLogo] = useState([]);
	const [isChecked1, setIsChecked1] = useState(false);
	const [isChecked2, setIsChecked2] = useState(false);
	const [isChecked3, setIsChecked3] = useState(false);
	const [isChecked4, setIsChecked4] = useState(false);
	const [isChecked5, setIsChecked5] = useState(false);
	const [isChecked6, setIsChecked6] = useState(false);
	const [isChecked7, setIsChecked7] = useState(false);
	const [isChecked8, setIsChecked8] = useState(false);
	const [logoPath, setlogoPath] = useState(
		process.env.REACT_APP_S3_URI +
		process.env.REACT_APP_S3_ENVIRONMEWNT_TYPE +
		process.env.REACT_APP_S3_HOSPITAL_LOGO_PATH
	);

	function styleValues(hospitalId) {
		const PostData = {
			hospitalId: localStorage.getItem('hospitalId'),
			doctorId: ""
		};

		callingAPI('commonUserFunctions/headerFooterLogoPrints', PostData)
			.then((res) => {
				setmarginbottom(res.data.result.headerFooterDetails[0].page_margin_bottom);
				setmargintop(res.data.result.headerFooterDetails[0].page_margin_top);
				setmarginleft(res.data.result.headerFooterDetails[0].page_margin_left);
				setmarginright(res.data.result.headerFooterDetails[0].page_margin_right);

				setpagesizeid(res.data.result.headerFooterDetails[0].page_size_id);
				setHospitalDetails(res.data.result.hospitalDetail[0])
				//setMarginTop()
			});

	}

	useEffect(() => {
		console.log('data111', printId);
		// console.log('id111', id);
		styleValues(printId.toString().split('|')[2])

		callingAPI('commonUserFunctions/getOrSendPrintprescription', {
			dentalLabOrderId: id,
			mode: ""
		}).then((res) => {
			setLabOrderListResult(res.data.result.printPrescriptionResult[0]);

			setMemberDetails(res.data.result.memberDetails[0]);
			setHospitalDetails(res.data.result.hospitalDetails[0]);
			setdoctorDetails(res.data.result.doctorDetails[0])
			setHospitalLogo(res.data.result.hospitalDetails[0].hospitalLogo);
			setlabordercreateddate(new Date(res.data.result.printPrescriptionResult[0].created_at).toLocaleDateString('en-GB'));
			// setSrandTotal(res.data.result[0].treatmentPlanResult[0].item[0].totalNetAmount);
			setIsData(true);

		});
	}, []);

	const printTreatment = () => {
		const section1 = document.getElementById('section1');
		const section21 = document.getElementById('section2.1');
		const section22 = document.getElementById('section2.2');
		const section23 = document.getElementById('section2.3');
		const section24 = document.getElementById('section2.4');
		const section25 = document.getElementById('section2.5');
		const section3 = document.getElementById('section3');


		// Hide unchecked sections before printing
		if (isChecked1) {
			section1.style.display = 'none';
		}
		if (isChecked2) {
			section21.style.display = 'none';
			section22.style.display = 'none';
			section23.style.display = 'none';
			section24.style.display = 'none';
			section25.style.display = 'none';
		}
		if (isChecked3) {
			section3.style.display = 'none';
		}


		// Hide print button temporarily
		document.getElementById('printButton').style.display = 'none';

		// Trigger print action
		const date = new Date();
		const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

		const originalTitle = document.title;
		document.title = `Lab order_${formattedDate}_${labOrderListResult.id}`;

       window.print();

	   	document.title = originalTitle


		// Show print button again
		document.getElementById('printButton').style.display = 'block';

		// Show all sections again after printing
		section1.style.display = '';
		section21.style.display = '';
		section22.style.display = '';
		section23.style.display = '';
		section24.style.display = '';
		section25.style.display = '';
		section3.style.display = '';

	};

	if (pagesizeid == '1') {
		var a4sizewidth = '540px'
		var a4sizeheight = '842px'
	}
	if (pagesizeid == '2') {
		var a5sizewidth = '420px'
		var a5sizeheight = '595px'
	}
	if (pagesizeid == '3') {
		var b4sizewidth = '780px'
		var b4sizeheight = '288px'
	}
	if (pagesizeid == '4') {
		var b5sizewidth = '540px'
		var b5sizeheight = '414px'
	}
	if (pagesizeid == '5') {
		var lettersizewidth = '792px'
		var lettersizeheight = '612px'
	}
	if (pagesizeid == '6') {
		var prescriptionsizewidth = '540px'
		var prescriptionsizeheight = '794px'
	}
	else {
		var a4sizewidth = '540px'
		var a4sizeheight = '842px'
	}
	
	return (
		<div align="center">
			<div
				align="center"
				style={{
					width: a4sizewidth || a5sizewidth || b4sizewidth || b5sizewidth || lettersizewidth || prescriptionsizewidth,
					height: a4sizeheight || a5sizeheight || b4sizeheight || b5sizeheight || lettersizeheight || prescriptionsizeheight,
					marginLeft: '0px',
					marginright: '0px',
					marginTop: '10px',
					marginBottom: '10px',
				}}
			>
				{isData === false ? <Loader /> : ''}
				<table style={{ width: '100%', marginLeft: marginleft + 'px', marginRight: marginright + 'px', marginTop: margintop + 'px', marginBottom: marginbottom + 'px' }} border="0">

					{/* <div className="no-print" style={{ position: "absolute", top: "70px", left: "-15px" }}><input checked={isChecked4} type="checkbox" onChange={(e) => setIsChecked4(e.target.checked)} /></div> */}
					<thead>
						<tr>
							<th style={{ fontWeight: '400' }}>
								<div class="printOutHeaderSec ">
									<table style={{ width: '100%' }}>
										<tbody>
											<HeaderPrint hospitalDataId={printId.toString().split('|')[2]} setIsChecked4={setIsChecked4} isChecked4={isChecked4} setIsChecked5={setIsChecked5} isChecked5={isChecked5} setIsChecked6={setIsChecked6} isChecked6={isChecked6} />


											<div class="caseSheetTop position-relative" id="section1">

												<div class="printOutHeaderSec "></div>
												{/* {doctorDetails.map((item, i) => ( */}
												<div class="caseDoctor">
													<div className="no-print  form-group cus-checkbox-wrpr">
														<input checked={isChecked1} id='isChecked1' type="checkbox" onChange={(e) => setIsChecked1(e.target.checked)} title="Hide the doctor's details while printing." />
														<label for="isChecked1" title="Hide the doctor's details while printing."></label>
													</div>
													<p>

														{doctorDetails.title}
														{doctorDetails.doctorDisplayName},
														{' '}
														{doctorDetails.education}
														{/* {item.speciality} */}

													</p>
													{/* <p>Council Reg. No.{item.medicalRegNumber}</p> */}
												</div>
												{/* ))} */}
											</div>

											<>
												<div className="no-print form-group cus-checkbox-wrpr" >
													<input checked={isChecked2} id='isChecked2' type="checkbox" onChange={(e) => setIsChecked2(e.target.checked)} title="Hide the patient's details while printing." />
													<label for="isChecked2" title="Hide the patient's details while printing."></label>
												</div>

												<tr id='section2.1'>
													<td
														colspan="6"
														style={{
															width: '50%',
															fontSize: '12px',
															padding: '0',
															lineHeight: '17px',
															textAlign: 'left',
														}}
													>
														Name : {memberDetails.memberFirstName}{' '}
														{memberDetails.memberLastName}
													</td>
													<td colspan="6"
														style={{

															width: '50%',
															fontSize: '12px',
															padding: '0',
															lineHeight: '17px',
															textAlign: 'right',
														}}
													>
														Date : {labordercreateddate}{' '}
													</td>
												</tr>

												<tr id='section2.2'>
													<td
														colspan="4"
														style={{
															width: '40%',
															fontSize: '12px',
															padding: '0',
															lineHeight: '17px',
															textAlign: 'left',
														}}
													>
														Age : {memberDetails.memberAge}
													</td>
													<td
														colspan="8"
														style={{
															width: '80%',
															fontSize: '12px',
															padding: '0',
															lineHeight: '17px',
															textAlign: 'right',
														}}
													>
														Email Id : {memberDetails.secUserEmailid}{' '}
													</td>
												</tr>
												<tr id='section2.3'>
													<td
														colspan="6"
														style={{
															width: '50%',
															fontSize: '12px',
															padding: '0',
															lineHeight: '17px',
															textAlign: 'left',
														}}
													>
														Sex : {memberDetails.memberGender}
													</td>
													<td colspan="6"
														style={{
															width: '50%',
															fontSize: '12px',
															padding: '0',
															lineHeight: '17px',
															textAlign: 'right',
														}}
													>
														Phone No : {memberDetails.SecuserMobileNumber}
													</td>
												</tr>
												<tr id='section2.4'>
													{window.sessionStorage.getItem('isPrNumEnabled') === "false" ?
														(<td
															colspan="6"
															style={{
																width: '50%',
																fontSize: '12px',
																padding: '0',
																lineHeight: '17px',
																textAlign: 'left',
															}}
														>
															MR No : {memberDetails.memberMrNo}
														</td>) :
														(!memberDetails.memberPrNo == "" &&
															<td
																colspan="6"
																style={{
																	width: '50%',
																	fontSize: '12px',
																	padding: '0',
																	lineHeight: '17px',
																	textAlign: 'left',
																}}
															>
																PR No : {memberDetails.memberPrNo}
															</td>
														)}

												</tr>

												<tr id='section2.5'>
													<td colspan="12">
														<hr
															color="#142536"
															style={{ margin: '0', opacity: '1', height: '2px' }}
														/>
													</td>
												</tr>
											</>
										</tbody>
									</table>
								</div>
							</th>
						</tr>
					</thead>

					<tbody id="section3">
						<div className="no-print form-group cus-checkbox-wrpr" >
							<input type="checkbox" checked={isChecked3} id='isChecked3' onChange={(e) => setIsChecked3(e.target.checked)} title="Hide the treatment plans while printing." />
							<label for="isChecked3" title="Hide the treatment plans while printing."></label>
						</div>
						<tr>
							<td>
								<div class="printOutSettingContent">
									<table width="100%" cellspacing="0">
										<tbody>
										
										</tbody>
									</table>
								</div>
							</td>
						</tr>


						<tr>
							<td>

								<div className="printPageContainer">
									<div className="formRow">
										<label>Work Type:</label>
										<div className="readonlyBox">{labOrderListResult.dental_lab_work_type}</div>
									</div>
									<div className="formRow">
										<label>Work Name:</label>
										<div className="readonlyBox">{labOrderListResult.dental_lab_work_name}</div>
									</div>
									<div className="formRow">
										<label>Tooth Nos:</label>
										<div className="readonlyBox">{labOrderListResult.tooth_number || ''}</div>
									</div>
									<div className="formRow">
										<label>Material:</label>
										<div className="readonlyBox">{labOrderListResult.dental_lab_alloy_type}</div>
									</div>
									<div className="formRow">
										<label>Tooth Shade:</label>
										<div className="readonlyBox">
											{labOrderListResult.dental_lab_shade} {labOrderListResult.dental_lab_sub_shade}
										</div>
									</div>
									<div className="formRow">
										<label>Stump Shade:</label>
										<div className="readonlyBox">{labOrderListResult.stump_shade}</div>
									</div>
									<div className="formRow">
										<label>Lab Name:</label>
										<div className="readonlyBox">{labOrderListResult.dental_lab_name}</div>
									</div>
								</div>

							</td>
						</tr>

                                  <div class="printLaborderStatus">
									<div className="formRow">
										<label>Status:</label>
										<div className="readonlyBox">{labOrderListResult.dental_lab_status}</div>
									</div>

									{labOrderListResult.dental_lab_status === "Dispatch To Lab" && (
										<div className="formRow">
											<label>Dispatch Date:</label>
											<div className="readonlyBox">
												{labOrderListResult.dispatchLabDate ? moment(labOrderListResult.dispatchLabDate).format("DD-MMM-YYYY h:mm a") : ""}
											</div>
										</div>
									)}

									{labOrderListResult.dental_lab_status === "On Hold" && (
										<div className="formRow">
											<label>On hold Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.onHoldDate ? moment(labOrderListResult.onHoldDate).format("DD-MMM-YYYY h:mm a") : ""}

											</div>
										</div>
									)}

									{labOrderListResult.dental_lab_status === "Overdue" && (
										<div className="formRow">
											<label>Overdue Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.overdueDate ? moment(labOrderListResult.overdueDate).format("DD-MMM-YYYY h:mm a") : ""}
											</div>
										</div>
									)}
									{labOrderListResult.dental_lab_status === "In Production" && (
										<div className="formRow">
											<label>In Production Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.inProductionDate ? moment(labOrderListResult.inProductionDate).format("DD-MMM-YYYY h:mm a") : ""}
											</div>
										</div>
									)}
									{labOrderListResult.dental_lab_status === "In Transit" && (
										<div className="formRow">
											<label>In Transit Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.inTransitDate ? moment(labOrderListResult.inTransitDate).format("DD-MMM-YYYY h:mm a") : ""}
											</div>
										</div>
									)}
										{labOrderListResult.dental_lab_status === "Received" && (
										<div className="formRow">
											<label>Received Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.receivedDate ? moment(labOrderListResult.receivedDate).format("DD-MMM-YYYY h:mm a") : ""}

											</div>
										</div>
									)}
										{labOrderListResult.dental_lab_status === "Delivered To Patient" && (
										<div className="formRow">
											<label>Received Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.deliveredToPatientDate ? moment(labOrderListResult.deliveredToPatientDate).format("DD-MMM-YYYY h:mm a") : ""}

											</div>
										</div>
									)}
										{labOrderListResult.dental_lab_status === "Repeat To Lab" && (
										<div className="formRow">
											<label>Repeat To Date:</label>
											<div className="readonlyBox">
											{labOrderListResult.repeatLabDate ? moment(labOrderListResult.repeatLabDate).format("DD-MMM-YYYY h:mm a") : ""}

											</div>
										</div>
									)}
									
									
									<div className="formRow">
										<label>Work Transfer Mode:</label>
										<div className="readonlyBox">{labOrderListResult.work_transfer_type}</div>
									</div>
									</div>

									<tr>
							<td>

								<div className="printPageContainer">
									<div className="formRow">
										<label style={{fontWeight: '400'}}>Instructions:</label>
										<div className="readonlyBox">{labOrderListResult.memo || '-'}</div>
									</div>
									</div>
									</td>
									</tr>
								
					</tbody>

					<FooterPrint setIsChecked7={setIsChecked7} isChecked7={isChecked7} />

				</table>
			</div>
			<div class="printBtm" style={{ textAlign: 'center' }}>
				<table style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td colspan="6" style={{ textAlign: 'center' }}>
								<p
									id="printButton"
									style={{
										width: '70px',
										textAlign: 'center',
										paddingTop: '5px',
										lineHeight: '18px',
										display: 'inline-block',
										fontWeight: 'bold',
										fontSize: '12px',
										color: 'white',
										background: 'rebeccapurple none repeat scroll 0% 0%',
										marginTop: '2px',
										cursor: 'pointer',
										borderRadius: '5px',
										marginBottom: '2px',
										height: '25px',
										position: 'absolute',
										right: '0px',
										fontFamily: '  Verdana',
									}}
									onClick={printTreatment}
								>
									Print
								</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default LabOrderListPrint;
